import { Paragraph } from "App/global-style";
import { BaseTile } from "Components/BaseTile";
import { useTileTexts } from "Store/texts/hooks";
import React from "react";
import { useEntrance } from "../../Products/Advice/ProductPrice/hooks/useEntrance";
import { AdviceLoginForm } from "./AdviceLoginForm";

export const AdviceLogin = (): React.ReactElement => {
  const [
    {
      loginTile: { adviceLogin: adviceLoginTexts },
    },
    lang,
  ] = useTileTexts();
  const entrance = useEntrance();
  const insuranceEntry = entrance ?? "default";
  return (
    <BaseTile header={adviceLoginTexts.header[insuranceEntry][lang]}>
      <Paragraph>
        {adviceLoginTexts.description[insuranceEntry].desc1[lang]}
      </Paragraph>
      <Paragraph>{adviceLoginTexts.description.desc2[lang]}</Paragraph>
      <Paragraph>{adviceLoginTexts.description.desc3[lang]}</Paragraph>
      <AdviceLoginForm />
    </BaseTile>
  );
};
